export default __webpack_public_path__ + "static/media/7.807d763e.webp";